export const LEVEL_MIN_ZOOM = 17;
